import {Alert, Button, Card, Popconfirm, Table, Tag, UploadFile} from "antd";
import React, {useContext, useEffect, useState} from "react";
import {ColumnsType, TableProps} from "antd/es/table";
import InscripcioContacte from "./InscripcioContacte";
import Colors from "../../../styles/Colors";
import {BiArrowBack, BiPlus, BiRefresh} from "react-icons/bi";
import {GetInscripcionsInscripcionsId} from "../../../dao/inscripcions/GetInscripcionsInscripcionsId";
import AlumneCasal from "../../../model/inscripcions/AlumneCasal";
import InscripcioModal from "./InscripcioModal";
import {PostInscripcionsInscripcioSwitch} from "../../../dao/inscripcions/PostInscripcionsInscripcioSwitch";
import {useParams} from "react-router-dom";
import {AuthContext} from "../../../config/AuthContext";
import toast, {Toaster} from "react-hot-toast";
import InscripcioModalDocumentacio from "./InscripcioModalDocumentacio";
import {GetInscripcionsIdAlumneIdDocuments} from "../../../dao/inscripcions/GetInscripcionsIdAlumneIdDocuments";
import dayjs from "dayjs";
import {GetInscripcionsActivitatIdTorn} from "../../../dao/inscripcions/GetInscripcionsInscripcioIdTorn";
import {GetInscripcionsActivitatIdExtres} from "../../../dao/inscripcions/GetInscripcionsInscripcioIdExtres";
import {GetInscripcionsIdInscripcionsId} from "../../../dao/inscripcions/GetInscripcionsIdInscripcionsId";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {GetInscripcionsIdInfants} from "../../../dao/inscripcions/GetInscripcionsIdInfants";

interface element {
    id_inscripcio: string,
    page: string,
    goBack: () => void,
    checkInscripcions: (value: boolean) => void,

}

const Inscripcio = (props: element) => {

    const [autoritzats, setAutoritzats] = useState<AlumneCasal[]>([]);

    const {id_inscripcio} = useParams();
    const [visible, setVisible] = useState(false);
    const [visibleDocuments, setVisibleDocuments] = useState(false);
    const [docs, setDocs] = useState<UploadFile[]>([]);
    const [loading, setLoading] = useState(false);
    const [edit, setEdit] = useState(false);
    const [novaInscripcio, setNovaInscripcio] = useState(false);

    const {isLoggedIn, userId, user, page, userDni, userCognom} = useContext(AuthContext);
    const [nouElement, setNouElement] = useState(false);
    const [elementSelected, setElementSelected] = useState<AlumneCasal>(new AlumneCasal());

    useEffect(() => {
        checkDades();
    }, []);

    const tableProps: TableProps<AlumneCasal> = {
        loading
    };

    const onChange: TableProps<AlumneCasal>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            //console.log('params', pagination, filters, sorter, extra);
        };

    function convertirJSON(jsonSegundo: any, trn: any, ext: any): any {

        let jsonPrimero: any = {
            infant: jsonSegundo.infant,
            escola: jsonSegundo.escola,
            curs: [jsonSegundo.cicle, jsonSegundo.curs],
            id_alumne_casal: jsonSegundo.key,
            id_inscripcio: jsonSegundo.id_inscripcio,
            alergens: jsonSegundo.alergens,
            observacions: jsonSegundo.observacions,
            activitat: [jsonSegundo.id_activitat, jsonSegundo.id_casal, jsonSegundo.id_campus, jsonSegundo.id_escola_entrada],
            comentaris: jsonSegundo.comentaris
        };

        trn.forEach((element: any, index: any) => {
            const key = `setmanes-${index}`;
            const filteredData = jsonSegundo.configuracions.filter((item: any) => item.id_torn === element.id);
            const formattedSetmanes = filteredData.length > 0 ? filteredData[0].setmanes.map((fecha: string) => dayjs(fecha)) : [];
            jsonPrimero[key] = formattedSetmanes;
        });
        trn.forEach((element: any, index: any) => {
            const key = `dies-${index}`;
            const filteredData = jsonSegundo.configuracions.filter((item: any) => item.id_torn === element.id);
            const formattedSetmanes = filteredData.length > 0 ? filteredData[0].dies.map((fecha: string) => dayjs(fecha)) : [];
            jsonPrimero[key] = formattedSetmanes;
        });


        ext.forEach((element: any, index: any) => {
            const key = `extra-${index}`;
            const filteredData = jsonSegundo.extres ? jsonSegundo.extres.filter((item : any) => item.id_extra === element.id && item.value !== '') : [];
            jsonPrimero[key] = filteredData.length > 0 ? (filteredData[0].valor === 'true' ? true :
                (filteredData[0].valor === 'false' ? false : filteredData[0].valor)) : undefined;
        });


        //console.log("-----" + JSON.stringify(jsonPrimero));
        return jsonPrimero;
    }


    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetInscripcionsInscripcionsId(props.id_inscripcio + "", props.page);
        const infants = await GetInscripcionsIdInfants(props.id_inscripcio +"",props.page);
        if (infants.length !== 0) setNovaInscripcio(true);
        console.log("ZZZZ"+infants.length)
        setAutoritzats(dades);
        props.checkInscripcions(dades.length > 0);
        //console.log(JSON.stringify(dades));
        handleLoadingChange(false);
    }

    const expandedRowRender = (ele: AlumneCasal) => {
        return (
            <InscripcioContacte element={ele}/>
        );
    };

    async function deleteElement(id: number) {
        //await DeleteIngredient(id, page);
        await checkDades();
    }

    function afegirElement(element: AlumneCasal) {
        setNouElement(!nouElement);
        setVisible(true);
        setElementSelected(element);
    }

    async function togleNouElement(element: AlumneCasal) {
        handleLoadingChange(true)

        const dad = await GetInscripcionsIdInscripcionsId(id_inscripcio + "", element.id_alumne_casal + "", page);
        //console.log(">>>>" + JSON.stringify(dad));

        const trn = await GetInscripcionsActivitatIdTorn(dad.id_casal, page);
        const ext = await GetInscripcionsActivitatIdExtres(dad.id_casal, page);

        setElementSelected(convertirJSON(dad, trn, ext));
        setNouElement(!nouElement);
        setVisible(true);
        handleLoadingChange(false);
    }

    async function switchInscripcio(ele: AlumneCasal) {
        handleLoadingChange(true)
        await PostInscripcionsInscripcioSwitch(id_inscripcio + "", page, ele);
        toast.success("GUARDAT");
        checkDades();
    }

    async function togleNouElementDocumentacio(ele: AlumneCasal) {
        const dds3 = await GetInscripcionsIdAlumneIdDocuments(id_inscripcio + " ", ele.id_alumne_casal + "", page);
        setDocs(dds3.fileList);
        setVisibleDocuments(true);
        setElementSelected(ele);
    }

    const columns: ColumnsType<AlumneCasal> = [
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            filterSearch: true,
            fixed: 'left',
            width: 80,
            render: (estat, ele) => (
                <>{ele.nom}{" "}{ele.cognoms}</>
            ),
        },
        {
            key: 'activitat',
            title: 'Activitat',
            dataIndex: 'activitat',
            width: 80,
            filterSearch: true,
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: 30,
            render: (estat, ele) => (
                <>
                    <Tag
                        color={ele.estat === 1 ? "success" : "warning"}>{ele.estat === 1 ? "AFEGIT" : "NO AFEGIT"}</Tag>
                </>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 120,
            render: (estat, ele) => (
                <>
                    {!window.location.pathname.endsWith('/documentacio') && <Button title={"Modificar"} style={{backgroundColor: Colors.colors.color6}}
                                onClick={() => togleNouElement(ele)}>MODIFICAR</Button>
                    }
                    {" "}
                    <Button title={"Documentació"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => togleNouElementDocumentacio(ele)}>DOCUMENTACIÓ</Button>
                    {" "}
                    {!window.location.pathname.endsWith('/documentacio') && <Button title={"Afegir / Treure"} style={{backgroundColor: Colors.colors.color4}}
                            onClick={() => switchInscripcio(ele)}>{ele.estat === 0 ? "AFEGIR" : "TREURE"}</Button>
                    }
                </>
            ),
        },
    ];

    async function onClose(value: boolean) {
        if (value) {
            toast.success("GUARDAT");
            await checkDades();
            setVisible(false);
            //const dds3 = await GetInscripcionsIdAlumneIdDocuments(id_inscripcio + " ", ele.id_alumne_casal + "", page);
            //setDocs(dds3.fileList);
            //setVisibleDocuments(true);
        } else {
            toast.error("NO GUARDAT");
            await checkDades();
            setVisible(false);
        }
    }

    function onCloseDocumentacio(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        checkDades();
        setVisibleDocuments(false);
    }

    return (
        <>
            <Toaster/>
            <div className={"actionButtons"}>
                <Button title={"Sortir"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                    props.goBack()}><BiArrowBack/> SORTIR</Button>{" "}
                <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                    checkDades()}><BiRefresh/> REFRESCAR</Button>{" "}

                {!window.location.pathname.endsWith('/documentacio') && novaInscripcio && <Popconfirm
                        title="NOVA INSCRIPCIÓ"
                        description={(<>{"Vols crear una nova inscripció? Prem el botó OK."} {autoritzats.length > 0 && (<><br/>
                            {"En cas de voler pujar documents fes-ho al botó de DOCUMENTACIÓ."} <br/>
                            {"En cas de voler modificar una existent no finalitzada al botó MODIFICAR."} <br/>
                            <b>{"Només cal crear nova inscripció per a un mateix infant si es vol canviar de casal."}</b></>)}
                        </>)}
                        onConfirm={() => afegirElement(new AlumneCasal())}
                        icon={<QuestionCircleOutlined style={{color: Colors.colors.color5}}/>}
                    >
                        <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}} ><BiPlus/> AFEGIR INSCRIPCIÓ</Button>
                    </Popconfirm>
                }
            </div>
            <h4 className={"titol"}>{"INSCRIPCIONS"}</h4>
            <Card bordered={true} className={"elemento"}>
                <Alert
                    message={"Afegeix una inscripció per cada activitat i infant. Cada infant pot tindre més d'una inscripció"}
                    type={"warning"}/>
                {!novaInscripcio && <Alert
                    message={"Cal tindre Infants donats d'alta a la pestanya anterior per poder crear una inscripció"}
                    type={"warning"}/>}
                <Alert
                    message={
                        <span>
                            Les inscripcions en estat <Tag color={"success"}>AFEGIT</Tag>són les que es tindrán en compte per la facturació
                        </span>
                    }
                    type="info"
                />
                <Table
                    {...tableProps}
                    onChange={onChange}
                    columns={columns}
                    scroll={{y: 240}}
                    dataSource={autoritzats}
                />
            </Card>
            {visible && <InscripcioModal element={elementSelected} visible={visible} onClose={onClose} page={props.page}
                                         edit={edit}/>}
            {visibleDocuments && <InscripcioModalDocumentacio element={elementSelected}
                                                              visible={visibleDocuments}
                                                              onClose={onCloseDocumentacio}
                                                              page={props.page}
                                                              idInsc={id_inscripcio+""}
                                                              documents={docs}
            />}
        </>
    );

};

export default Inscripcio;